<template>
  <b-modal :visible="modal" @hide="closeModal">
    <div slot="modal-title">
      {{  $t('hideUnhideLicenses', { typeText: capitalizeWord(typeText) }) }}
    </div>
    <b-container class="text-center" fluid>
     <b-row>
        <div class="col-12">
          <h5 class="title">
            {{$t('hideUnhideLicensesModalTitle', {
              count: this.selectedLicenses.length,
              typeText,
              license: this.selectedLicenses.length === 1 ? $t('license') : $tc('licenses', 2)
            })}}
          </h5>
          <div class="description">
            {{ hideUnhideLicensesModalDescription }}
          </div>
        </div>
      </b-row>
      <b-row style="padding-top: 30px;">
        <div class="col-6">
          <b-button
            class="hide-modal-btn btn-c-outline"
            variant="primary"
            size="lg"
            @click="performHideUnhide"
          >
            {{ $t('yes') }}
          </b-button>
        </div>
        <div class="col-6">
          <b-button
            class="hide-modal-btn btn-c-outline"
            variant="primary"
            size="lg"
            @click="closeModal"
          >
            {{ $t('no') }}
          </b-button>
        </div>
      </b-row>
    </b-container>
    <div slot="modal-footer" />
  </b-modal>
</template>

<script>
export default {
  name: 'HideUnhideModal',
  props: {
    modal: { type: Boolean, required: true },
    closeModal: { type: Function, required: true },
    selectedLicenses: { type: Array, required: true },
    type: { type: String, required: true },
    onSuccessfulAction: { type: Function, required: true }
  },
  computed: {
    typeText () {
      return this.type === 'hide' ? this.$tc('hide', 2) : this.$tc('unhide', 2)
    },
    loggedInUser () {
      return this.$store.getters.authToken.userName || ''
    },
    hideUnhideLicensesModalDescription () {
      return this.type === 'hide'
        ? this.$t('hideLicensesModalDescription')
        : this.$t('unhideLicensesModalDescription')
    }
  },
  methods: {
    capitalizeWord ([firstChar, ...rest]) {
      return `${firstChar.toUpperCase()}${rest.join('')}`
    },
    performHideUnhide () {
      this.bottle.post(
        this.UrlBuilder.archiveLicensesUrl,
        this.selectedLicenses.map(l => ({
          SerialNumber: l.ActivationID,
          loggedInUser: this.loggedInUser,
          customerID: this.$store.getters.person.customerId,
          ProductName: l.ProductName,
          Action: this.type === 'hide' ? 'archive' : 'unarchive'
        }))
      )
        .then(({ data }) => {
          this.onSuccessfulAction(true)
          this.closeModal()
        })
        .catch((error) => {
          this.loggly.log({
            errorMessage: `License ${this.type}ing failed`,
            errorObject: error,
            errorStack: error.stack
          })
          this.closeModal()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../styles/variables.scss';

  .title {
    font-size: 26px;
    color: $success;
    font-weight: 400;
  }

  .description {
    font-size: 18px;
  }

  .hide-modal-btn {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/HideUnhideModal.vue